import React, { useEffect, useRef, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const INTERVALLE = 5 * 60 * 1000;

/** Bandeau « Nouvelle version disponible » (09/10/2026) : compare la version en ligne (/api/version) à celle chargée
 *  à l'ouverture, toutes les 5 minutes et au retour sur l'onglet. Rien à faire pour l'utilisateur sinon recharger. */
export default function NouvelleVersion() {
  const initiale = useRef(null);
  const [nouvelle, setNouvelle] = useState(false);

  useEffect(() => {
    let actif = true;
    const verifier = async () => {
      try {
        const r = await fetch(`${API_URL}/api/version`, { cache: 'no-store' });
        if (!r.ok) return;
        const sha = (await r.json())?.sha;
        if (!sha || !actif) return;
        if (!initiale.current) initiale.current = sha;
        else if (sha !== initiale.current) setNouvelle(true);
      } catch { /* hors ligne : on réessaiera */ }
    };
    verifier();
    const t = setInterval(verifier, INTERVALLE);
    const auRetour = () => { if (document.visibilityState === 'visible') verifier(); };
    document.addEventListener('visibilitychange', auRetour);
    return () => { actif = false; clearInterval(t); document.removeEventListener('visibilitychange', auRetour); };
  }, []);

  if (!nouvelle) return null;
  return (
    <div className="fixed left-3 right-3 bottom-20 z-50 mx-auto max-w-md rounded-lg bg-[#1F4E79] text-white shadow-lg px-4 py-3 flex items-center gap-3"
      role="status" data-testid="nouvelle-version">
      <span className="text-sm flex-1">Une nouvelle version de l’application est disponible.</span>
      <button onClick={() => window.location.reload()} className="shrink-0 inline-flex items-center gap-1 rounded-md bg-white text-[#1F4E79] text-sm font-semibold px-3 py-1.5"
        data-testid="nouvelle-version-recharger">
        <RefreshCw className="w-4 h-4" /> Recharger
      </button>
    </div>
  );
}
